import { Input } from '@angular/core';
import { Getter } from './interfaces';
import { OverlayOptions } from './amap-overlay';
import { AMapShapeOverlay } from './amap-shape-overlay';
import { EventBinderService } from '../shared/event-binder.service';

export const PathOverlayOptions = [
  ...OverlayOptions,
  'visible',
  'zIndex',
  'strokeColor',
  'strokeOpacity',
  'strokeWeight',
  'strokeStyle',
  'strokeDasharray',
  'lineJoin',
  'lineCap',
];

export class AMapPathOverlay<T extends AMap.EventEmitter> extends AMapShapeOverlay<T> {
  // ---- Options ----
  /**
   * æ¯å¦å¯è§
   */
  @Input() visible: boolean;
  /**
   * è¦çç©å±çº§
   */
  @Input() zIndex: number;
  /**
   * æè¾¹çº¿æ¡é¢è²
   */
  @Input() strokeColor: string;
  /**
   * æè¾¹çº¿æ¡éæåº¦
   */
  @Input() strokeOpacity: number;
  /**
   * æè¾¹å®½åº¦
   */
  @Input() strokeWeight: number;
  /**
   * æè¾¹æ ·å¼
   */
  @Input() strokeStyle: AMap.StrokeStyle;
  /**
   * èçº¿é´é
   */
  @Input() strokeDasharray: number[];
  /**
   * æçº¿æç¹çç»å¶æ ·å¼
   */
  @Input() lineJoin: AMap.StrokeLineJoin;
  /**
   * æçº¿ä¸¤ç«¯çº¿å¸½çç»å¶æ ·å¼
   */
  @Input() lineCap: AMap.StrokeLineCap;

  constructor(protected os: Getter<T>, protected binder: EventBinderService) {
    super(os, binder);
  }
}
